import React from "react";
import DiscoverHelper from "./DiscoverHelper";
import { useOutletContext } from "react-router-dom";

export function DiscoverHelperPage() {
  const { isAdmin } = useOutletContext();

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-200">
          Discover Helper
        </h2>
        <p className="mt-2 text-sm text-gray-400">
          Tools to help with Discover calculations
        </p>
      </div>
      <div className="bg-[#18181B] rounded-xl shadow-xl shadow-black/20 p-4 sm:p-6">
        <DiscoverHelper isAdmin={isAdmin} />
      </div>
    </div>
  );
}
